import React, { Component } from "react";
import NumberFormat from "react-number-format";

// CSS
import "../../css/forms/phone-field.css";

/**
 * This component will allow the dyanmic inserting/deleting of a list of phone numbers.
 * Difference between PhoneField and PhoneFieldArray is that this is meant for use within the DynamicInputs component.
 * The phone numbers will be an array, and not a static set of fields (such as contact_phone, contact_phone_extension would be a static set of fields).
 */
class PhoneFieldArray extends Component {
	render() {
		const { label, valueObj, dataName, index, translations, disabledField } = this.props;
		const inProcess = this.props.inProcess ? this.props.inProccess : false;

		return (
			<div className="phone-field-wrapper half-field">
				{!!label && <label htmlFor="phone">{label}:</label>}

				<div className="phone-inputs">
					<div className="phone-field phone-field--main">
						<NumberFormat
							name={dataName}
							placeholder="555 555 5555"
							value={valueObj.phone}
							type="tel"
							format="### ### ####"
							mask="_"
							disabled={inProcess | disabledField}
							onKeyPress={e => this.props.handleKeyPress(e)}
							onValueChange={values =>
								this.props.handleInputChangeArray(
									{
										target: {
											name: dataName,
											value: { ...valueObj, phone: values.value }
										}
									},
									index
								)
							}
						/>
					</div>

					<div className="phone-field phone-field--extension">
						<label htmlFor="phone_extension">
							{!!translations ? translations.sections.form_elements.extension : "Ext"}
							:
						</label>
						<NumberFormat
							name={dataName}
							placeholder="1234"
							value={valueObj.extension}
							type="tel"
							format="#####"
							mask="_"
							disabled={inProcess | disabledField}
							onKeyPress={e => this.props.handleKeyPress(e)}
							onValueChange={values =>
								this.props.handleInputChangeArray(
									{
										target: {
											name: dataName,
											value: { ...valueObj, extension: values.value }
										}
									},
									index
								)
							}
						/>
					</div>
				</div>
			</div>
		);
	}
}

export default PhoneFieldArray;



// WEBPACK FOOTER //
// ./src/components/utils/PhoneFieldArray.js